export default {
  title: 'Word lid van {{name}}!',
  default_program_name: 'Beloningsclub',
  benefits: {
    earn_points: 'Verdien punten bij elke bestelling',
    get_deals: 'Ontvang exclusieve kortingen',
    redeem_points: 'Wissel punten in voor gratis eten',
  },
  terms: 'Door je aan te melden ontvang je e-mail- en sms-aanbiedingen van ons&nbsp;',
  buttons: {
    log_in: 'Inloggen',
    sign_up: 'Aanmelden',
  },
  labels: {
    already_have_account: 'Heb je al een account?',
  },
  signup_note:
    'Door je aan te melden ontvang je e-mail- en sms-aanbiedingen van ons <0>restaurant</0> en <1>FoodAmigos</1>, onze technologiepartner. Je gaat akkoord met onze <2>Platformvoorwaarden</2> en <3>Privacybeleid</3>.',
};
